import DetailsTitle from "components/common/detailsPage/DetailsTitle";
import InfoItem from "components/common/detailsPage/InfoItem";
import HorizontalScroller from "components/common/HorizontalScroller";
import DetailsShimmer from "components/common/shimmer/DetailsShimmer";
import { CustomerStatusBadge } from "components/common/StatusBadge";
import { usePermission } from "hooks/usePermission";
import { useQueryParam } from "hooks/useQueryParam";
import React, { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails } from "store/slices/usersSlice";
import { formatUTCDate } from "utils/utils";

function UserDetails() {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const dispatch = useDispatch();
  const id = useQueryParam("id");

  const { itemDetails: userDetails, loading } = useSelector(
    (state) => state.Users,
  );
  useEffect(() => {
    if (id) {
      dispatch(getUserDetails(id));
    }
  }, [id, dispatch]);
  const { _id, name, email, phoneNumber, status, createdAt, roleId } =
    userDetails || {};
  const infoFields = [
    {
      label: t("Id"),
      // value: _id || "-",
      render: <HorizontalScroller>{_id}</HorizontalScroller>,
      col: { lg: 6, xs: 6 },
    },
    {
      label: t("Name"),
      value: name || "-",
      col: { lg: 6, xs: 6 },
    },
    { isSpacer: true },
    {
      label: t("Phone Number"),
      value: phoneNumber || "-",
      col: { lg: 6, xs: 6 },
    },
    {
      label: t("Email"),
      render: <HorizontalScroller>{email}</HorizontalScroller>,
      col: { lg: 6, xs: 6 },
    },
    { isSpacer: true },
    {
      label: t("Status"),
      render: <CustomerStatusBadge status={status} t={t} />,
      col: { lg: 6, xs: 6 },
    },
    {
      label: t("Role"),
      value: language === "en" ? roleId?.name : roleId?.nameAr || "",
      col: { lg: 6, xs: 6 },
    },
    { isSpacer: true },
    {
      label: t("Created Date"),
      value: formatUTCDate(createdAt),
      col: { lg: 6, xs: 6 },
    },
  ];
  const shimmerLayout = [
    {
      col: 6,
      blocks: [
        { rows: 4, cols: 2 },
        { rows: 1, cols: 1 },
      ],
    },
    {
      col: 6,
      blocks: [{ rows: 4, cols: 2 }],
    },
  ];
  if (loading) {
    return (
      <div className="page-content">
        <DetailsTitle title={t("User Details")} />
        <DetailsShimmer layout={shimmerLayout} />
      </div>
    );
  }
  return (
    <div className="page-content common_details_page user_details">
      <DetailsTitle title={t("User Details")} />
      <Row>
        <Col lg={6}>
          <div className="common_card h-100">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex gap-2">
                <h2 className="title_20">{t("Basic Details")}</h2>
              </div>
            </div>
            <div className="general_details_wrapper">
              <Row>
                {infoFields
                  .filter((item) => item.show !== false)
                  .map((item, index) => {
                    if (item.isSpacer) {
                      return <div key={index} className="mt-4 w-100" />;
                    }

                    return (
                      <InfoItem
                        key={index}
                        label={item.label}
                        value={item.value}
                        col={item.col}
                      >
                        {item.render}
                      </InfoItem>
                    );
                  })}
              </Row>
            </div>
          </div>
        </Col>
        {!roleId?.hasFullPermissions && (
          <Col lg={6}>
            <div className="common_card h-100">
              <h2 className="title_20">{t("Permissions Details")}</h2>

              <Row>
                {roleId?.permissions?.map((module) => (
                  <Col md={6} key={module.id}>
                    <div className="single_permission">
                      <h6>{t(module.module)}</h6>

                      <div className="permission_wrapper">
                        {module?.permissions?.map((perm) => (
                          <Form.Check
                            key={perm.id}
                            type="checkbox"
                            label={t(perm)}
                            checked
                            disabled
                          />
                        ))}
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
}

export default UserDetails;
